import { OverlayModule } from '@angular/cdk/overlay';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { PopupFactoryService } from './popups/popup-factory.service';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AuthModule } from './auth/auth.module';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgxsModule, NoopNgxsExecutionStrategy } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { AppState } from './store/app.state';
import { DatePipe } from '@angular/common';
import { ChooseDocumentsModule } from './popups/choose-documents/choose-documents.component';
import { UploadDocumentModule } from './popups/upload-document/upload-document.component';
import { ErrorMessageInterceptor } from './auth/interceptors/error-message.interceptor';
import { CalendarState } from './dashboard/store/calendar/calendar.state';
import { AdmissionsCalendarState } from './dashboard/store/admissions-calendar/admissions-calendar.state';
import { ChooseDocumentsAdmissionModule } from './popups/choosed-documents-admission/choose-documents-admission.component';
import { ComponentsModule } from './shared/components-old/components.module';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CustomErrorHandler } from './custom-error-handler';
import { OnlineStatusModule } from 'ngx-online-status';
import { ConnectionComponent } from './popups/connection/connection.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxsStoragePluginModule, SESSION_STORAGE_ENGINE } from '@ngxs/storage-plugin';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PatientProfileInterceptor } from './shared/interseptors/patient-profile.interceptor';
import { LoadingState } from './dashboards-new/store/loading/loading.state';
import { cacheInterceptor, dedupeInterceptor } from './dashboards-new/interseptor/dedupe.interceptor';

@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    OverlayModule,
    AuthModule,
    AppRoutingModule,
    SharedModule,
    LoadingBarHttpClientModule,
    ChooseDocumentsModule,
    ChooseDocumentsAdmissionModule,
    UploadDocumentModule,
    NgxsFormPluginModule.forRoot(),
    NgxsModule.forRoot([AppState, CalendarState, AdmissionsCalendarState, LoadingState], {
      executionStrategy: NoopNgxsExecutionStrategy,
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({
      name: 'AAC',
      disabled: false,
    }),
    NgxsStoragePluginModule.forRoot({
      keys: [
        {
          key: 'filters',
          engine: SESSION_STORAGE_ENGINE,
        },
        // todo: move to tests module once we update nxgs to v18 (current one doesn't support storage module for lazy loaded states)
        {
          key: 'tests',
          engine: SESSION_STORAGE_ENGINE,
        },
      ],
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgScrollbarModule,
    OverlayModule,
    ComponentsModule,
    OnlineStatusModule,
    ConnectionComponent,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ToastNoAnimationModule.forRoot(),
  ],
  providers: [
    DatePipe,
    PopupFactoryService,
    NgxImageCompressService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorMessageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PatientProfileInterceptor,
      multi: true,
    },
    {
      provide: 'API_URL',
      useValue: environment.apiUrl,
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => (): void => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    ...(environment.production
      ? [
          {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
        ]
      : []),
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(withInterceptors([dedupeInterceptor])),
    provideHttpClient(withInterceptors([cacheInterceptor])),
  ],
})
export class AppModule {}
